module.exports = __webpack_public_path__ + "img/7_189.657fed56.png";